import { STORAGE_PREFIX } from '@domain/storage';

export const getStorageID = (id: string) => `${STORAGE_PREFIX}${id}`;
